import React from "react";

function PdfIcon({ fill, ...restProps }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M4.75 4C4.75 2.20508 6.20508 0.75 8 0.75H24C24.1212 0.75 24.2375 0.798159 24.3232 0.883885L35.1161 11.6768C35.2018 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4Z"
        stroke="#D0D5DD"
        stroke-width="1.5"
      />
      <path
        d="M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5"
        stroke="#D0D5DD"
        stroke-width="1.5"
      />
      <path
        d="M25.7088 25.344C24.586 25.344 23.1808 25.5399 22.7211 25.6088C20.8184 23.6218 20.277 22.4924 20.1553 22.1913C20.3203 21.7673 20.8944 20.1566 20.976 18.088C21.0162 17.0523 20.7975 16.2785 20.3256 15.7879C19.8545 15.2981 19.2843 15.26 19.1208 15.26C18.5475 15.26 17.5857 15.5499 17.5857 17.4914C17.5857 19.1759 18.3711 20.9633 18.5882 21.4252C17.4443 24.7556 16.2163 27.0356 15.9556 27.5044C11.3594 29.2349 11 30.9081 11 31.3823C11 32.2345 11.6069 32.7432 12.6234 32.7432C15.0932 32.7432 17.347 28.5967 17.7197 27.8767C19.4738 27.1778 21.8216 26.7449 22.4184 26.6416C24.1304 28.2724 26.1104 28.7075 26.9326 28.7075C27.5512 28.7075 28.9999 28.7075 28.9999 27.218C29 25.8348 27.2271 25.344 25.7088 25.344ZM25.5898 26.3219C26.9238 26.3219 27.2764 26.7631 27.2764 26.9963C27.2764 27.1427 27.2208 27.6203 26.5058 27.6203C25.8646 27.6203 24.7575 27.2497 23.6683 26.4456C24.1225 26.3859 24.7947 26.3219 25.5898 26.3219ZM19.0508 16.2079C19.1724 16.2079 19.2525 16.2469 19.3185 16.3385C19.7022 16.8709 19.3928 18.6105 19.0163 19.9718C18.6528 18.8046 18.38 17.0135 18.7638 16.3834C18.8388 16.2604 18.9246 16.2079 19.0508 16.2079ZM18.4029 26.6277C18.8859 25.652 19.4272 24.23 19.722 23.4257C20.3121 24.4134 21.1057 25.3303 21.5647 25.8275C20.1356 26.1288 19.0543 26.4298 18.4029 26.6277ZM11.9594 31.5125C11.9276 31.4748 11.9229 31.3952 11.9469 31.2997C11.9971 31.0995 12.3814 30.1074 15.1608 28.8641C14.7628 29.491 14.1407 30.3867 13.4572 31.0558C12.9761 31.5062 12.6014 31.7345 12.3437 31.7345C12.2515 31.7345 12.1244 31.7094 11.9594 31.5125Z"
        fill="#D92D20"
      />
    </svg>
  );
}

export default PdfIcon;
